module.exports = __webpack_public_path__ + "static/media/Iconfield04.5967a5c1.svg";